import styled from '@emotion/styled';
import { theme } from '../../design-system';
import { Flex } from '.';

const StyledRadioButton = styled('input')`
  accent-color: ${theme.colors.secondary};
`;

const Label = styled('label')`
  margin-left: 0.5rem;
`;
const RadioButton = ({ value, checked, onChange, id, label }) => {
  return (
    <Flex>
      <StyledRadioButton type='radio' value={value} checked={checked} onChange={onChange} />
      <Label htmlFor={id}>{label}</Label>
    </Flex>
  );
};

export default RadioButton;
